// src/components/product-top-rated-attribute/product-top-rated-attribute.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment ProductTopRatedAttributeInfoFragment on ProductTextInfoSection {\n    icon {\n      id\n      description\n    }\n    title {\n      text\n      accessibility\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  query ProductTopRatedAttributeQuery($context: ContextInput!, $productIdentifier: ProductIdentifierInput!) {\n    topRatedAttribute(context: $context, productIdentifier: $productIdentifier) {\n      impressionAnalytics {\n        linkName\n        referrerId\n      }\n      primary {\n        productAttribute {\n          ...ProductTopRatedAttributeInfoFragment\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import React2 from "react";
import { gql as gql2, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
// src/components/product-top-rated-attribute/__private/__fragments/product-top-rated-attribute-info.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
var fragment = gql(_templateObject());
var productTopRatedAttributeSpacing = function(page) {
    switch(page){
        case "REVIEWS_OVERLAY" /* REVIEWS_OVERLAY */ :
        case "REVIEWS_BOTTOM" /* REVIEWS_BOTTOM */ :
            return {
                margin: {
                    blockstart: "one"
                },
                padding: {
                    blockend: "two"
                }
            };
        case "PROPERTY_SUMMARY" /* PROPERTY_SUMMARY */ :
            return {
                margin: {
                    blockend: "two"
                }
            };
        default:
            return null;
    }
};
var ProductTopRatedAttributeInfo = function(param) {
    var data = param.data, location = param.location;
    var icon = data.icon, title = data.title;
    if (!(icon && title)) {
        return null;
    }
    var ProductTopRatedAttributeIcon = /* @__PURE__ */ React.createElement(UitkIcon, {
        name: (icon === null || icon === void 0 ? void 0 : icon.id.toLocaleLowerCase()) || "",
        description: icon === null || icon === void 0 ? void 0 : icon.description,
        size: UitkIconSize.SMALL
    });
    var ProductTopRatedAttributeText = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(UitkText, {
        inline: true,
        "aria-hidden": "true"
    }, title.text), /* @__PURE__ */ React.createElement("span", {
        className: "is-visually-hidden"
    }, (title === null || title === void 0 ? void 0 : title.accessibility) || ""));
    return /* @__PURE__ */ React.createElement(UitkSpacing, _object_spread({}, productTopRatedAttributeSpacing(location)), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(UitkLayoutFlex, {
        space: "two"
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, ProductTopRatedAttributeIcon), /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, ProductTopRatedAttributeText))));
};
ProductTopRatedAttributeInfo.fragment = fragment;
ProductTopRatedAttributeInfo.displayName = "ProductTopRatedAttributeInfo";
// src/components/product-top-rated-attribute/product-top-rated-attribute.tsx
var __Query = gql2(_templateObject1(), ProductTopRatedAttributeInfo.fragment);
var ProductTopRatedAttributePresent = /* @__PURE__ */ function(ProductTopRatedAttributePresent2) {
    ProductTopRatedAttributePresent2["REVIEWS_OVERLAY"] = "REVIEWS_OVERLAY";
    ProductTopRatedAttributePresent2["REVIEWS_BOTTOM"] = "REVIEWS_BOTTOM";
    ProductTopRatedAttributePresent2["PROPERTY_SUMMARY"] = "PROPERTY_SUMMARY";
    return ProductTopRatedAttributePresent2;
}(ProductTopRatedAttributePresent || {});
var productTopRatedAttributeContent = function(impressionReferrerId, impressionLinkName, content, page) {
    switch(page){
        case "PROPERTY_SUMMARY" /* PROPERTY_SUMMARY */ :
            return /* @__PURE__ */ React2.createElement(IntersectionTracker, {
                trackOnce: true,
                referrerId: impressionReferrerId,
                linkName: impressionLinkName
            }, content);
        default:
            return content;
    }
};
var ProductTopRatedAttribute = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr, batchKey = param.batchKey, present = param.present;
    var _variables_productIdentifier_travelSearchCriteria_property, _variables_productIdentifier_travelSearchCriteria, _variables_productIdentifier;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var isReviewsSummary = {
        id: "isReviewsSummary",
        value: present === "REVIEWS_BOTTOM" /* REVIEWS_BOTTOM */ 
    };
    var isFilteredSummary = {
        id: "isFilteredSummary",
        value: present === "REVIEWS_OVERLAY" /* REVIEWS_OVERLAY */ 
    };
    var updatedCriteria = null;
    if ((_variables_productIdentifier = variables.productIdentifier) === null || _variables_productIdentifier === void 0 ? void 0 : (_variables_productIdentifier_travelSearchCriteria = _variables_productIdentifier.travelSearchCriteria) === null || _variables_productIdentifier_travelSearchCriteria === void 0 ? void 0 : (_variables_productIdentifier_travelSearchCriteria_property = _variables_productIdentifier_travelSearchCriteria.property) === null || _variables_productIdentifier_travelSearchCriteria_property === void 0 ? void 0 : _variables_productIdentifier_travelSearchCriteria_property.secondary) {
        updatedCriteria = JSON.parse(JSON.stringify(variables));
        updatedCriteria.productIdentifier.travelSearchCriteria.property.secondary.booleans = [
            isReviewsSummary,
            isFilteredSummary
        ];
    }
    var DEFAULT_BATCH_KEY = "default-product-details-experience-batch-key";
    var fetchPolicy = present === "REVIEWS_OVERLAY" /* REVIEWS_OVERLAY */  || present === "REVIEWS_BOTTOM" /* REVIEWS_BOTTOM */  ? "cache-first" : "no-cache";
    var _useQuery = useQuery(__Query, {
        context: {
            batchKey: batchKey !== null && batchKey !== void 0 ? batchKey : DEFAULT_BATCH_KEY
        },
        variables: updatedCriteria !== null && updatedCriteria !== void 0 ? updatedCriteria : variables,
        fetchPolicy: fetchPolicy,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data || !data.topRatedAttribute) {
        return null;
    }
    var _data_topRatedAttribute = data.topRatedAttribute, primary = _data_topRatedAttribute.primary, impressionAnalytics = _data_topRatedAttribute.impressionAnalytics;
    var productAttributeContent = /* @__PURE__ */ React2.createElement(React2.Fragment, null, (primary === null || primary === void 0 ? void 0 : primary.productAttribute) ? /* @__PURE__ */ React2.createElement(ProductTopRatedAttributeInfo, {
        data: primary.productAttribute,
        location: present
    }) : "");
    var impressionReferrerId = (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId) || "";
    var impressionLinkName = (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) || "";
    return /* @__PURE__ */ React2.createElement("div", {
        "data-stid": "product-top-rated-attribute"
    }, productTopRatedAttributeContent(impressionReferrerId, impressionLinkName, productAttributeContent, present));
};
ProductTopRatedAttribute.displayName = "sharedui-ProductTopRatedAttribute";
// src/__generated__/types.ts
var IdentifierType = /* @__PURE__ */ function(IdentifierType2) {
    IdentifierType2["ACTIVITY_ID"] = "ACTIVITY_ID";
    IdentifierType2["CART_ID"] = "CART_ID";
    IdentifierType2["CHECKOUT_SESSION_ID"] = "CHECKOUT_SESSION_ID";
    IdentifierType2["ENTITY_ID"] = "ENTITY_ID";
    IdentifierType2["LEGACY_ORDER_ID"] = "LEGACY_ORDER_ID";
    IdentifierType2["OFFER_ID"] = "OFFER_ID";
    IdentifierType2["ORDER_ID"] = "ORDER_ID";
    IdentifierType2["PROPERTY_ID"] = "PROPERTY_ID";
    IdentifierType2["SAILING_TOKEN"] = "SAILING_TOKEN";
    return IdentifierType2;
}(IdentifierType || {});
export { IdentifierType, ProductTopRatedAttribute, ProductTopRatedAttributePresent };
//# sourceMappingURL=index.js.map